export default __webpack_public_path__ + "static/media/icon-play-circle.9ccda429.svg";